module.exports = __webpack_public_path__ + "static/media/活体支付_lg.4f758ee6.jpg";